import _ from 'lodash';
import { action, observable, makeObservable } from 'mobx';
import { ConfirmModalParams } from 'core/models';
import { BaseViewStore } from 'core/stores';
import { localStorageHandler } from 'core/services';

class WizardStore extends BaseViewStore {
	@observable wizardStep;
	exitPage;
	promise;

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
	}

	@action.bound initialize(config, form, key, name, parentView) {
		this.suspend();
		this.config = config;
		this.wizardName = name;
		this.localStorageKey = key;
		this.currentStepLocalStorage = this.localStorageKey + '-current-step';
		this.wizardStep = this.getCurrentStep(config);
		this.stepForm = form;
		this.checkValidity = parentView.checkFormValidity;
		this.checkValidityForStep = parentView.checkValidityForStep;
		this.resume();
	}

	leavePageConfirm = new ConfirmModalParams({
		onConfirm: async () => {
			this.promise(true);
			this.leavePageConfirm.close();
		},
		onCancel: async () => {
			this.promise(false);
			this.leavePageConfirm.close();
		},
	});

	async openModalOnStateChange() {
		this.leavePageConfirm.open({
			message: 'PRODUCT.WIZARD.LEAVECONFIRM',
		});
		return new Promise(resolve => {
			this.promise = resolve;
		});
	}

	getCurrentStep(config) {
		let currentStepIndex = localStorageHandler.get(this.currentStepLocalStorage);
		if (currentStepIndex) {
			return config[currentStepIndex];
		}
		return _.head(config);
	}

	getStepName = stepNumber => {
		return _.find(this.config, steps => {
			return steps.order == stepNumber;
		}).name;
	};

	routeForUpdate() {
		if (this.rootStore.routerStore.routerState.params.id) {
			return true;
		}
		return false;
	}

	saveToStorage() {
		let stepValues = this.stepForm.values();
		localStorageHandler.set(this.localStorageKey, stepValues);
	}

	@action.bound onNextStep(step, stepDirection) {
		let index = _.findIndex(this.config, function(item) {
			return item.component === step.component;
		});
		let nextStepNumber = index + stepDirection;
		let currentStepNumber = index + 1;
		if (!this.routeForUpdate()) {
			this.saveToStorage(currentStepNumber);
		}

		let nextStep = this.config[nextStepNumber];
		if (index > -1 && nextStep) {
			this.navigateToStep(nextStep);
		}
	}

	@action.bound navigateToStep(step) {
		let currentComponent = this.wizardStep.component;
		let currentStepNumber =
			_.findIndex(this.config, function(item) {
				return item.component === currentComponent;
			}) + 1;

		if (!this.routeForUpdate()) {
			this.saveToStorage(currentStepNumber);
		}
		this.wizardStep = step;

		this.checkValidityForStep(currentStepNumber);
	}
}

export default WizardStore;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/stores/WizardStore.js